import { settings } from '../settings';

async function fetchFeriadosAnio(año: number): Promise<string[]> {
    const baseUrl = settings.url.argentinadatos;
    const res = await fetch(`${baseUrl}/${año}`);
    if (!res.ok) throw new Error(`fetchFeriados ${año}: HTTP ${res.status}`);
    const data: { fecha: string; tipo: string; nombre: string }[] = await res.json();
    return data.map((f) => f.fecha);
}

export async function fetchFeriadosSet(...años: number[]): Promise<Set<string>> {
    const results = await Promise.all(años.map(fetchFeriadosAnio));
    return new Set(results.flat());
}
